'use strict';

import type { UserEmailBatchQueue } from '../../Entities/User/UserEmailBatchQueue';
import { EntityCollection } from '../EntityCollection';

export class UserEmailBatchQueueCollection extends EntityCollection<UserEmailBatchQueue> {}
